import DIApi from './_diApi';

class InvoiceFormNumberAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'InvoiceFormNumbers';
}

export default new InvoiceFormNumberAPI();
